import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vant from 'vant'
import { Lazyload } from 'vant';
import http from './utils/http'
import dateUitl from './utils/dateUtil'
import pathUitl from './utils/path'
import './views/pages/index'
import './components/index'
import 'vant/lib/index.css'
import './bootstrap.min.css'
const wx = require('weixin-js-sdk')
// import Vconsole from "vconsole";
// Vue.prototype.$vconsole = new Vconsole() // 使用vconsole
Vue.config.productionTip = false
Vue.use(vant)
Vue.use(Lazyload);

// 注册时可以配置额外的选项
Vue.use(Lazyload, {
  lazyComponent: true,
});
Vue.prototype.$http = http

Vue.prototype.$uitl = {
  formatTime: dateUitl.formatTime,
  getPathQuery: pathUitl.getPathQuery
}
Vue.prototype.$getType = function (text: any) {
  return Object.prototype.toString.call(text)
}
window.wx = wx
let vue = new Vue({
  router,
  store,
  render: h => h(App)
})
vue.$mount('#app')
